import { Button } from "@devhop/ui";
import { Building2, HelpCircle, PlusIcon, Settings2Icon } from "lucide-react";

type DocumentsToolbarProps = {
  canCreate: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
  /** When set, show "ຈັດການປະເພດເອກະສານ" button that opens document type management modal */
  onManageDocumentTypes?: () => void;
  canManageIssuerSettings?: boolean;
  onIssuerSettings?: () => void;
};

export function DocumentsToolbar({
  canCreate,
  onCreate,
  onStartTour,
  onManageDocumentTypes,
  canManageIssuerSettings,
  onIssuerSettings,
}: DocumentsToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-4" data-tourid="documents-toolbar">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="text-2xl font-bold tracking-tight">ເອກະສານການເງິນ</h2>
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={onStartTour}
              >
                <HelpCircle className="size-5" />
              </Button>
            )}
          </div>
          <p className="text-muted-foreground">
            ພາບລວມ ແລະ ຈັດການເອກະສານການເງິນ
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {canManageIssuerSettings && onIssuerSettings && (
            <Button variant="outline" size="sm" onClick={onIssuerSettings}>
              <Building2 className="mr-2 h-4 w-4" />
              ຕັ້ງຄ່າຜູ້ອອກເອກະສານ
            </Button>
          )}
          {onManageDocumentTypes && (
            <Button variant="outline" size="sm" onClick={onManageDocumentTypes}>
              <Settings2Icon className="mr-2 h-4 w-4" />
              ຈັດການປະເພດເອກະສານ
            </Button>
          )}
          {canCreate && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງເອກະສານໃໝ່
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
